import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ContractManagementService } from '../contract-management.service';
import * as ContractManagementActions from './contract-management.actions';
import { switchMap, map, catchError, flatMap } from 'rxjs/operators';
import { of } from 'rxjs';
import {
    ResponseStatus,
    IStatusMessage,
    DisplayMessageMinimum
} from '../../shared';
import * as fromShared from '../../shared';

@Injectable()
export class ContractManagementEffects {
    constructor(
        private actions$: Actions,
        private service: ContractManagementService
    ) {}

    getContracts$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ContractManagementActions.getContracts),
            switchMap(a =>
                this.service.getContracts(a.Activeonly).pipe(
                    flatMap(resp => [
                        ContractManagementActions.loadContractManagements({
                            contractManagements: resp
                        }),
                        new fromShared.Errors.RemoveErrors(
                            resp
                                .filter(
                                    x =>
                                        x.Status.StatusCode ===
                                        ResponseStatus.Success
                                )
                                .map(x => x.ContractListID)
                        ),
                        new fromShared.Errors.SetErrors(
                            [
                                ...resp
                                    .filter(
                                        a =>
                                            a.Status.StatusCode >=
                                            DisplayMessageMinimum
                                    )
                                    .map(a => a.Status)
                            ].filter(fromShared.Errors.filterErrors)
                        )
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    putContracts$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ContractManagementActions.putContracts),
            switchMap(a =>
                this.service.putContractMgmt(a.contracts).pipe(
                    flatMap(c => [
                        ContractManagementActions.updateContractManagements({
                            contractManagements: [
                                {
                                    id: a.contracts
                                        .map(x => x.ContractListID)
                                        .toString(),
                                    changes: c.Items[0]
                                }
                            ]
                        }),

                        // ContractManagementActions.getContracts({ Activeonly: a.Activeonly }),
                        new fromShared.Errors.RemoveErrors(
                            c.Items.filter(
                                x =>
                                    x.Status.StatusCode ===
                                    ResponseStatus.Success
                            ).map(x => x.ContractListID.toString())
                        ),
                        new fromShared.Errors.SetErrors(
                            [
                                ...c.ErrorMessages.map(
                                    x =>
                                        ({
                                            StatusCode: -1,
                                            Message: x,
                                            MsgProcessID: 0,
                                            MsgEntityID: ''
                                        } as IStatusMessage)
                                ),
                                ...c.Items.filter(
                                    x =>
                                        x &&
                                        x.Status.StatusCode >=
                                            DisplayMessageMinimum
                                ).map(x => x.Status)
                            ].filter(fromShared.Errors.filterErrors)
                        )
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        )
    );
}
